// extracted by mini-css-extract-plugin
export default {"checkboxGroupWrapper":"inputStyles_checkboxGroupWrapper__hRbo8","checkboxGroup":"inputStyles_checkboxGroup__fhoRi","checkboxGroupError":"inputStyles_checkboxGroupError__ZkuEj"};